"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntitiesOperator = void 0;
const ethers_1 = require("ethers");
const crypto_1 = require("@dcl/crypto");
const ContentClient_1 = require("dcl-catalyst-client/dist/client/ContentClient");
const DeploymentBuilder_1 = require("dcl-catalyst-client/dist/client/utils/DeploymentBuilder");
const eth_1 = require("./eth");
const peer_1 = require("./peer");
const fetch_component_1 = require("@well-known-components/fetch-component");
class EntitiesOperator {
    constructor(peerUrl, peerWithNoGbCollectorUrl) {
        this.peerUrl = peerUrl;
        this.peerWithNoGbCollectorUrl = peerWithNoGbCollectorUrl;
        this.catalystContentClient = (0, ContentClient_1.createContentClient)({ url: `${peerUrl}/content`, fetcher: (0, fetch_component_1.createFetchComponent)() });
        this.catalystContentClientWithoutGbCollector = peerWithNoGbCollectorUrl
            ? (0, ContentClient_1.createContentClient)({ url: `${peerUrl}/content`, fetcher: (0, fetch_component_1.createFetchComponent)() })
            : null;
        this.peerAPI = new peer_1.PeerAPI(peerUrl);
    }
    /**
     * Uses the provider to request the user for a signature to
     * deploy an entity.
     *
     * @param address - The address of the deployer of the entity.
     * @param entityId - The entity id that it's going to be deployed.
     */
    authenticateEntityDeployment(address, entityId) {
        return __awaiter(this, void 0, void 0, function* () {
            const provider = yield (0, eth_1.getConnectedProvider)();
            if (!provider)
                throw new Error("The provider couldn't be retrieved when creating the auth chain");
            const eth = new ethers_1.ethers.providers.Web3Provider(provider);
            const personal = eth.getSigner(address);
            const signature = yield personal.signMessage(entityId);
            return crypto_1.Authenticator.createSimpleAuthChain(entityId, address, signature);
        });
    }
    /**
     * Gets the first {@link ProfileEntity} out of multiple possible profile entities or
     * returns the last one in case the given address has no profile entities.
     *
     * @param address - The address that owns the profile entity being retrieved.
     */
    getProfileEntity(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const entities = yield this.catalystContentClient.fetchEntitiesByPointers([address.toLowerCase()]);
            if (entities.length > 0) {
                return entities[0];
            }
            return this.peerAPI.getDefaultProfileEntity();
        });
    }
    /**
     * Deploys an entity of a determined type.
     * This method will build everything related to the deployment of
     * the entity and will prompt the user for their signature before
     * doing a deployment.
     *
     * @param entity - The title of the book.
     * @param entityType - The type of the entity.
     * @param address - The owner / soon to be owner of the entity.
     */
    deployEntityWithoutNewFiles(entityMetadata, hashesByKey, entityType, pointer, address) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                type: entityType,
                pointers: [pointer],
                metadata: entityMetadata,
                hashesByKey,
                timestamp: Date.now()
            };
            const catalystContentClient = (_a = this.catalystContentClientWithoutGbCollector) !== null && _a !== void 0 ? _a : this.catalystContentClient;
            const contentUrl = (_b = this.peerWithNoGbCollectorUrl) !== null && _b !== void 0 ? _b : this.peerUrl;
            const entityToDeploy = yield (0, DeploymentBuilder_1.buildEntityWithoutNewFiles)((0, fetch_component_1.createFetchComponent)(), Object.assign({ contentUrl: `${contentUrl}/content` }, options));
            const authChain = yield this.authenticateEntityDeployment(address, entityToDeploy.entityId);
            return catalystContentClient.deploy(Object.assign(Object.assign({}, entityToDeploy), { authChain }));
        });
    }
}
exports.EntitiesOperator = EntitiesOperator;
//# sourceMappingURL=entities.js.map